export function TargetChildIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g transform="translate(3 3)">
        <path id="Vector" d="M12.3333 1C6.07411 1 1 6.07411 1 12.3333C1 14.5367 1.6288 16.5933 2.71674 18.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <g transform="translate(23.95 11.67)">
        <path id="Vector" d="M1.00013 9.66667C2.08807 7.92663 2.71687 5.87008 2.71687 3.66667V1H6.05018" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <g transform="translate(7 21.67) translate(7.333 0) scale(-1 1)">
        <path id="Vector" d="M3.66667 6.33333C5.13943 6.33333 6.33333 5.13943 6.33333 3.66667C6.33333 2.19391 5.13943 1 3.66667 1C2.19391 1 1 2.19391 1 3.66667C1 5.13943 2.19391 6.33333 3.66667 6.33333Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <g transform="translate(16.33 21.67) translate(7.333 0) scale(-1 1)">
        <path id="Vector" d="M3.66667 6.33333C5.13943 6.33333 6.33333 5.13943 6.33333 3.66667C6.33333 2.19391 5.13943 1 3.66667 1C2.19391 1 1 2.19391 1 3.66667C1 5.13943 2.19391 6.33333 3.66667 6.33333Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <g transform="translate(14.33 3)">
        <path id="Vector 36" d="M1 1V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <g transform="translate(3.67 15)">
        <path id="Vector 37" d="M1 1H22.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}
